import { Grid } from '@mui/material';
import clsx from 'clsx';

import AdditionalInfo from './AdditionalInfo';
import AssignedUser from './AssignedUser';
import Comment from './Comment';
import ContractInfo from './ContractInfo';
import { useStyles } from './style';
import TermsAndConditions from './TermsAndConditions';
import SummaryLoading from '../../../OrganisationManagement/Details/OrganisationDetails/Summary/SummaryLoading/SummaryLoading';

interface SummaryProps {
	className?: string;
	contractData?: object;
	loading?: boolean;
}

const Summary = (props: SummaryProps) => {
	const { className, contractData, loading } = props;

	const classes = useStyles();

	const gridProps = { item: true, xs: 12, md: 6, lg: 6, xl: 4 };

	return contractData && loading ?
			<Grid className={clsx(classes.root, className)} container spacing={3}>
				<Grid {...gridProps}>
					<ContractInfo contractData={contractData} />
				</Grid>
				<Grid {...gridProps}>
					<AdditionalInfo contractData={contractData} />
				</Grid>
				{contractData?.status !== 'rejected' ?
					<Grid {...gridProps}>
						<AssignedUser contractData={contractData} />
					</Grid>
				:	null}
				<Grid {...gridProps}>
					<TermsAndConditions contractData={contractData} />
				</Grid>
				<Grid {...gridProps}>
					<Comment contractData={contractData} />
				</Grid>
			</Grid>
		:	<SummaryLoading />;
};

export default Summary;
